import { Injectable } from '@angular/core';
import {Http} from '@angular/http';
import {Constants} from '../../shared/Constants';
import {Router} from '@angular/router';
import {HelperFunctions} from "../../shared/HelperFunctions";

@Injectable()
export class AuthService {


  constructor(public http: Http, public router: Router) {
  }
// make auth
  public auth(authPayload: any){
    return this.http.post(Constants.LOGIN_URL + '?username=' + encodeURIComponent(authPayload.username) + '&password='
      + encodeURIComponent(authPayload.password), Constants.getRequestHeader()).
      map(res => res.json());
  }
// get user profile data
  public getProfile(token: string) {
    return this.http.get(Constants.PROFILE_URL, Constants.getRequestOption(token))
      .map(res => res.json());
  }
  // get agent profile data
  public getAgentProfile(token: string) {
    return this.http.get(Constants.AGENT_PROFILE_URL, Constants.getRequestOption(token))
      .map(res => res.json());
  }

  // get customer profile data
  public getCustomerProfile(id:number, token: string) {
    return this.http.get(Constants.USERS_URL + id, Constants.getRequestOption(token))
      .map(res => res.json());
  }


// reset password
  public resetPassword(email: string) {
    return this.http.get(Constants.RESET_PASSWORD_URL + '?email=' + email, Constants.getRequestHeader())
      .map(res => res.json());
  }
// create password
  createPassword(password: any) {
    return this.http.put(Constants.CREATE_PASSWORD_URL, password,  Constants.getRequestHeader())
  }
// create roles
  createRoles(rolesPayload: any) {
    return this.http.post(Constants.CREATE_ROLES_URL, rolesPayload,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }
// update roles
  updateRoles(rolesPayload: any, id: number) {
    return this.http.put(Constants.UPDATE_ROLES_URL + id, rolesPayload,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }
// create super agent

  createAgent(agentData: any, formData) {
    let payload = '';
    for (let key in agentData){
      if (agentData.hasOwnProperty(key)){
        payload += '' + key + '=' + agentData[key] + '&';
      }
    }

    payload = payload.replace(/&+$/g, ''); // remove the trailing &
     // console.log("******* payload ********");
     // console.log(payload);
    return this.http.post(Constants.CREATE_AGENT_URL + payload, formData, Constants.getMultipartRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }


  createAgentSelf(agentData: any, formData) {
    let payload = '';
    console.log(agentData);
    for (let key in agentData) {
      if (agentData.hasOwnProperty(key)) {
        payload += '' + key + '=' + (encodeURIComponent(agentData[key])) + '&';
      }
    }

    payload = payload.replace(/&+$/g, ''); // remove the trailing &

    console.log(payload);
     // console.log('******* payload ********');
     // console.log(payload);
    return this.http.post(Constants.CREATE_AGENT_SELF_URL + payload, formData, Constants.getMultipartRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  // create customer
  createCustomer(customerData: any, formData) {
     // console.log("******* payload ********");
     // console.log(customerData);
    return this.http.post(Constants.CREATE_CUSTOMER_URL, customerData, Constants.getMultipartRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }


  changePassword(passwordPayload: any) {
    console.log(passwordPayload);
    return this.http.put(Constants.CHANGE_PASSWORD_URL, passwordPayload, Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  // multiple user by uploading sheet
  createMultipleUser(roleId: any, formData: FormData) {
    return this.http.post(Constants.UPLOAD_USER_DATA_URL + '?roleId=' + roleId, formData, Constants.getMultipartRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }


// refresh token or get new access token
  refreshToken() {
    return this.http.get(Constants.REFRESH_TOKEN_URL, Constants.getRefreshTokenRequestOption(localStorage.getItem(Constants.REFRESH_TOKEN)))
      .map(res => res.json());
  }


// save access and refresh token to local storage
  saveToken(accessToken: string, refreshToken: string, callback ?: Function) {
    localStorage.setItem(Constants.REFRESH_TOKEN, refreshToken);
    localStorage.setItem(Constants.ACCESS_TOKEN,  accessToken);
    if(callback){
      callback();
    }
  }
// save user profile to local stirage
  saveProfile(profileData: any){
    localStorage.setItem(Constants.PROFILE, profileData);
  }

  public getToken(): string {
    return localStorage.getItem(Constants.ACCESS_TOKEN);
  }

  public getRefreshToken(): string {
    return localStorage.getItem(Constants.REFRESH_TOKEN);
  }




// logout service
  logout() {
    localStorage.clear();
    location.reload();
    this.router.navigate([Constants.SIGNIN_URL]);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/authentication/auth-service.service.ts